class TagView extends HTMLElement {
    constructor() {
        super();
        this.obj = null;
    }

    static get boundAttributes() {
        return ['tags', 'more-available', 'name', 'size', 'file-id'];
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this[attrName] = newValue;
    }

    connectedCallback() {
        const root = this;

        this._wrapper = document.createElement('div');
        this._wrapper.classList.add('file-tags');
        this._wrapper.classList.add('tag-view');

        if (this.size === "small") {
            this._wrapper.classList.add('small');
        }

        root.appendChild(this._wrapper);

        const self = this;

        const resizeObserver = new ResizeObserver((entries) => {
            self.render();
        });

        resizeObserver.observe(this._wrapper);

        this.render();
    }

    disconnectedCallback() {

    }

    get tags() {
        return this.getAttribute('tags');
    }

    set tags(_tags) {
        this.setAttribute("tags", _tags);
        this.render();
    }

    get more_available() {
        return !!this.getAttribute('more-available');
    }

    set more_available(_more) {
        this.setAttribute("more-available", _more);
        this.render();
    }

    get file_id() {
        return this.getAttribute('file-id');
    }

    set file_id(_file_id) {
        this.setAttribute("file-id", _file_id);
        this.render();
    }

    get name() {
        return this.getAttribute('name');
    }

    set name(_name) {
        this.setAttribute("name", _name);
    }

    get size() {
        return this.getAttribute('size');
    }

    set size(_size) {
        this.setAttribute("size", _size);
    }

    tagsAsArray() {
        if (this.tags) {
            return this.tags.trim().split(",");
        }

        return [];
    }

    render() {
        // Remove existing tags
        this._wrapper.innerHTML = '';

        const tagArray = this.tagsAsArray();
        let truncated = false;

        for (const tag of tagArray) {
            if (tag !== "") {
                const search_params = {
                    scope: 1, match: [
                        {key: "tag", type: 0, val: tag}
                    ]
                };

                this._wrapper.insertAdjacentHTML('beforeend', `<a href="files?searchparams=${utf8ToBase64(JSON.stringify(search_params))}"><div class="tag">${tag}</div></a>`);

                // Check if it's exceeding its bounds
                if (this._wrapper.scrollWidth > this._wrapper.clientWidth) {
                    const children = this._wrapper.childNodes;
                    this._wrapper.removeChild(children.item(children.length - 1));
                    truncated = true;
                    break;
                }
            }
        }

        if (this.more_available || truncated) {
            const moreBtn = document.createElement('div');
            moreBtn.textContent = '...';
            moreBtn.setAttribute('data-file-id', this.file_id);
            moreBtn.classList.add('tag');
            moreBtn.classList.add('tag-more');

            if (this.size === 'small') {
                moreBtn.classList.add('small');
            }

            this._wrapper.appendChild(moreBtn);

            // Check if it's exceeding its bounds
            while (this._wrapper.scrollWidth > this._wrapper.clientWidth && this._wrapper.childNodes > 1) {
                const children = this._wrapper.childNodes;
                this._wrapper.removeChild(children.item(children.length - 2));
            }

            setupTagEvents($(this._wrapper));
        }
    }
}

customElements.define('tag-view', TagView);